import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from "./PercentageCalculator";
const TITLE =
  "Calculer 5% d'un montant - Calculatrice 5 pour cent - Apprenez combien font 5%";
const DESCRIPTION =
  "Calculer 5% d pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "r 5% d, calculatrice r 5% d, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/5percent/";
function Calculator() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "17px" }}>
                  Comment calculer 5% d'une valeur spécifique :
                </h2>
                <ul>
                  <li>
                    Multipliez la valeur par 5% sous forme de fraction. Le pourcentage 5% peut être représenté comme une fraction de la manière suivante : 5/100.
                  </li>
                  <li>
                    Ensuite, multipliez la valeur originale par la fraction. Supposons que vous ayez une certaine valeur dont vous souhaitez calculer 5%, disons que cette valeur est égale à 100, vous pouvez utiliser l'équation suivante :
                    <br />
                    Le pourcentage = (Valeur originale × Fraction 5/100)
                  </li>
                  <li>
                    Ou vous pouvez simplement effectuer le calcul comme suit : divisez la valeur originale par 20.
                    <br />
                    Le pourcentage = Valeur originale / 20
                  </li>
                  <li>Vous obtiendrez le pourcentage requis, qui est 5% de la valeur originale.</li>
                </ul>
                <ul>
                  Cette calculatrice calcule également :<li> 1 pour cent </li>
                  <li> 2 pour cent</li>
                  <li> 3 pour cent</li>
                  <li> 4 pour cent</li>
                  <li> 5 pour cent </li>
                  <li> 6 pour cent </li>
                  <li> 7 pour cent</li>
                  <li> 8 pour cent </li>
                  <li> 9 pour cent </li>
                </ul>
                <b>
                  Vous pouvez également utiliser la calculatrice électronique suivante pour calculer 5% d'un nombre ou d'un montant spécifique :
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <PercentageCalculator percentage={5} />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />

    </div>
  );
}
export default Calculator;
